import { getStore } from "app/store/store"
import { normalizeSync } from "normalize-diacritics"
import { IOrder } from "order/model"
import { orderRPO } from "order/repository"

export function getOrderById(orderId: number): Promise<IOrder> {
  return orderRPO.getOrder(orderId)
}

export const getOrderByIds = (orderIds: number[]): Promise<IOrder[]> => orderRPO.getOrdersById(orderIds)

export function getOrderNameById(orderId: number): string {
  const order = getStore().getState().order.orders.find(o => o.id === orderId)
  return order?.name || ""
}

export function getAllOrderIds(): number[] {
  return getStore().getState().order.orders.map(o => o.id)
}

export function orderExistsByName(name: string): boolean {
  if (!name || !name.trim()) {
    return false
  }
  const normalizedName = normalizeSync(name).toLowerCase()
  return getStore().getState().order.orders.find(o => o.normalizedName === normalizedName) !== undefined
}

export const getOrderAdvertiserIdByName = (name: string): number | null =>
  getStore().getState().order.orders.find(o => o.normalizedName === normalizeSync(name).toLowerCase()).advertiser_id
